import React from "react";

import mouse from '../../assets/svgs/Tutorial/Mouse_clic.svg'
import bolita from '../../assets/svgs/Tutorial/bolita.svg'

interface ControlTutorialProps {
    closeTutorial: boolean,
    isSceneLoaded: boolean,
    isTouchScreen: boolean,
    isFullTutorial: boolean,
    isPortrait: boolean,
}

const ControlTutorial: React.FC<ControlTutorialProps> = ({ closeTutorial, isSceneLoaded, isPortrait, isTouchScreen, isFullTutorial}) => {

  const [showTutorial, setShowTutorial] = React.useState(false);
  
  React.useEffect(() => {
    setTimeout(() => { setShowTutorial(true); }, 1000)
  }, []);

  return (
    <div className={`drag-animation-container ${isPortrait ? 'portrait':''} ${(showTutorial && isSceneLoaded && !closeTutorial) ? 'fade-in':'fade-out'}`}>
      {isTouchScreen === true ? 
      <div className={`drag-animation-container-main ${isPortrait ? 'portrait':''}`}>
        <img src={bolita} alt='' className={`drag-animation-mouse ${isPortrait ? 'portrait':''} drag-animation-mouse-move`}/>
        <div className={`drag-animation-text tablets-text ${isPortrait ? 'portrait':''}`}>Desliza para rotar 360°</div>
      </div>
      :
      <div className={`drag-animation-container-main ${isPortrait ? 'portrait':''}`}>
        <img src={mouse} alt='' className={`drag-animation-mouse ${isPortrait ? 'portrait':''} drag-animation-mouse-move`}/>
        <div className={`drag-animation-text ${isPortrait ? 'portrait':''}`}>Arrastra el cursor para rotar 360°</div>
      </div>
      }
      {isFullTutorial && <div className={`drag-animation-hr ${isPortrait ? 'portrait':''}`}/>}
      {(isFullTutorial && isTouchScreen === true) &&
        <div className={`drag-animation-container-main ${isPortrait ? 'portrait':''}`}>
          <img src={bolita} alt='' className='drag-animation-mouse-center-top drag-animation-touch-center-top'/>
          <img src={bolita} alt='' className='drag-animation-mouse-center-bottom drag-animation-touch-center-bottom'/>
          <div className={`drag-animation-text ${isPortrait ? 'portrait':''}`}>Pellizca para acercar o alejar el modelo</div>
        </div>
      }
      {(isFullTutorial && isTouchScreen === false) &&
        <div className={`drag-animation-container-main ${isPortrait ? 'portrait':''}`}>
          <div className="drag-animation-scroll-downs">
            <div className="drag-animation-mousey">
              <div className="drag-animation-scroller"></div>
            </div>
          </div>
          <div className={`drag-animation-text ${isPortrait ? 'portrait':''}`}>Usa scroll para acercar o alejar el modelo</div>
        </div>
      }
    </div>
  );
};

export default ControlTutorial;
